import { assertNotNull } from '../../../../helpers/nullHelpers';
import { assertIsNumberOrNull } from '../../../../helpers/numberHelpers';
import { DownlossTypeCode } from '../../quote-or-design-form/rooms/heatLoss/downlossTypeCode';
import { RoomFloorHeatLossDetailsFormModel } from '../../quote-or-design-form/rooms/heatLoss/roomFloorHeatLossDetailsFormModel';

export type CreateUpdateRoomFloorHeatLossDetailsDto = {
  displayIndex: number;
  roomAreaPercentage: number | null;
  downlossTypeCode: DownlossTypeCode;
  temperatureBelowInDegreesCelsius: number | null;
};

export const mapRoomFloorHeatLossDetailsFormModelToDto = (
  formModel: RoomFloorHeatLossDetailsFormModel,
  displayIndex: number,
): CreateUpdateRoomFloorHeatLossDetailsDto => ({
  displayIndex,
  roomAreaPercentage: assertIsNumberOrNull(formModel.roomAreaPercentage),
  downlossTypeCode: assertNotNull(formModel.downlossTypeCode),
  temperatureBelowInDegreesCelsius: assertIsNumberOrNull(formModel.temperatureBelowInDegreesCelsius),
});
